// Offline fallback mirroring the backend's PAGE_DEFAULTS (filterPropertyPool.js) for when no config was ever cached
const field = (key, label, inputType = "text", kind = "property") => ({
  key,
  label,
  inputType: kind === "special" ? "special" : inputType,
  operator: "EQ",
  hubspotProperty: kind === "special" && key === "team" ? null : key,
  kind,
});

const CONTACT_FIELDS = [
  field("firstname", "First Name"),
  field("lastname", "Last Name"),
  field("residence_address_line_1", "Street Address", "text", "special"),
  field("team", "Team", "text", "special"),
  field("residence_city", "City", "text", "special"),
  field("residence_zip", "Zip Code"),
  field("age", "Age", "number"),
  field("state_income_decile", "State Income Decile", "select"),
  field("national_voter_cluster", "National Voter Cluster", "select"),
  field("census_block", "Census Block"),
  field("presence_of_children_code", "Presence of Children Code", "select"),
  field("languages", "Language", "select"),
  field("estimated_income_range", "Estimated Income Range", "select"),
];

const withoutTeam = (fields) => fields.filter((f) => f.key !== "team");

export const DEFAULT_FILTER_FIELDS = {
  database: CONTACT_FIELDS,
  walking_list: withoutTeam(CONTACT_FIELDS),
  households: [
    { ...field("residence_address_line", "Street Address", "text", "special") },
    field("team", "Team", "text", "special"),
    field("residence_city", "City", "text", "special"),
    field("residence_zip", "Zip Code"),
    field("census_block", "Census Block"),
    field("presence_of_children_code", "Presence of Children Code", "select"),
  ],
  canvass_map: [
    { ...field("street_name", "Street Name", "text", "special"), hubspotProperty: "residence_address_line" },
    field("residence_city", "City", "text", "special"),
    field("census_block", "Census Block"),
    field("presence_of_children_code", "Presence of Children Code", "select"),
    field("residence_zip", "Zip Code"),
    field("house_number_type", "House Number", "text", "special"),
  ],
};
